import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: easing }}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for large display text
export const MaskLines = ({ lines, className = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * 0.12, ease: easing }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const ImageReveal = ({ src, alt, className = "", imgClassName = "" }) => (
  <div className={`overflow-hidden ${className}`}>
    <motion.img
      src={src}
      alt={alt}
      loading="lazy"
      className={`h-full w-full object-cover ${imgClassName}`}
      initial={{ scale: 1.25, opacity: 0.4 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1.2, ease: easing }}
    />
  </div>
);

export default Reveal;
